module.exports = __webpack_public_path__ + "img/cover_photo.1573a27e.jpg";